import { API, TrackerDataType } from '../constants/constants';

export type DetailedCsvExportMode = 'monthly' | 'filter' | 'fuzzy';

export interface DetailedCsvExportContext {
  trackerType: TrackerDataType;
  mode: DetailedCsvExportMode;
  month?: string;
  timezoneOffset?: string;
  filterQueryString?: string;
  queryString?: string;
  category?: string;
}

interface DetailedCsvExportPrecheckResponse {
  allowed: boolean;
  sizeBytes: number;
  message?: string;
}

const trackerEndpointMap: Record<TrackerDataType, string> = {
  [TrackerDataType.MEDIA_INTERACTION]: '/issues/detailed-csv',
  [TrackerDataType.SERVICE]: '/services/detailed-csv',
  [TrackerDataType.ENGAGEMENT]: '/engagements/detailed-csv',
  [TrackerDataType.CONTENT_LOG]: '/content-logs/detailed-csv',
  [TrackerDataType.COMBINED_INTERACTION_AND_SERVICE]: '',
  [TrackerDataType.MANAGER_ANALYTICS]: '',
  [TrackerDataType.CLIENT_ANALYTICS]: '',
};

const buildEndpoint = (trackerType: TrackerDataType, action: 'precheck' | 'download') => {
  const basePath = trackerEndpointMap[trackerType];
  if (!basePath) {
    throw new Error(`unsupported tracker type: ${trackerType}`);
  }

  return `${basePath}/${action}`;
};

const buildParams = (context: DetailedCsvExportContext) => ({
  mode: context.mode,
  month: context.month,
  timezoneOffset: context.timezoneOffset,
  filterQueryString: context.filterQueryString,
  queryString: context.queryString,
  category: context.category,
});

export const checkDetailedCsvExport = async (context: DetailedCsvExportContext) => {
  const response = await API.get<DetailedCsvExportPrecheckResponse>(buildEndpoint(context.trackerType, 'precheck'), {
    params: buildParams(context),
  });

  return response.data;
};

export const downloadDetailedCsvExport = async (context: DetailedCsvExportContext) => {
  const response = await API.get<Blob>(buildEndpoint(context.trackerType, 'download'), {
    params: buildParams(context),
    responseType: 'blob',
  });

  const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8' });
  const objectUrl = globalThis.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = `${Date.now()}-${context.trackerType}-detailed.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  globalThis.URL.revokeObjectURL(objectUrl);
};
